import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { useSection } from "./useSection";
import { Field, SaveBar } from "./ui";
import { ImageField } from "./ImageField";

export default function CompanyEditor({ logout }) {
  const { draft, setDraft, saving, save } = useSection("company", logout);
  if (!draft) return null;

  const set = (k, v) => setDraft({ ...draft, [k]: v });
  const hours = draft.hours || [];
  const setHour = (i, k, v) => set("hours", hours.map((h, idx) => (idx === i ? { ...h, [k]: v } : h)));
  const addHour = () => set("hours", [...hours, { d: "", h: "" }]);
  const removeHour = (i) => set("hours", hours.filter((_, idx) => idx !== i));

  return (
    <div>
      <SaveBar title="Azienda" description="Contatti, indirizzo, social e orari mostrati sul sito." saving={saving} onSave={save} />

      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Nome" value={draft.name} onChange={(v) => set("name", v)} />
        <Field label="Slogan" value={draft.tagline} onChange={(v) => set("tagline", v)} />
        <Field label="Anno di fondazione" value={draft.since} onChange={(v) => set("since", v)} />
        <Field label="P. IVA" value={draft.piva} onChange={(v) => set("piva", v)} />
        <Field label="Telefono (mostrato)" value={draft.phone} onChange={(v) => set("phone", v)} />
        <Field label="Telefono (link, es. +393331793343)" value={draft.phoneHref} onChange={(v) => set("phoneHref", v)} />
        <Field label="WhatsApp (numero, es. 393331793343)" value={draft.whatsapp} onChange={(v) => set("whatsapp", v)} />
        <Field label="Email" value={draft.email} onChange={(v) => set("email", v)} />
        <div className="md:col-span-2">
          <Field label="Indirizzo" value={draft.address} onChange={(v) => set("address", v)} />
        </div>
        <Field label="Facebook (URL)" value={draft.facebook} onChange={(v) => set("facebook", v)} />
        <Field label="Instagram (URL)" value={draft.instagram} onChange={(v) => set("instagram", v)} />
      </div>

      <div className="mt-8 max-w-md">
        <ImageField label="Logo" value={draft.logo} onChange={(v) => set("logo", v)} logout={logout} ratio="aspect-square" />
      </div>

      <div className="mt-10">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm uppercase tracking-[0.18em] text-navy/60">Orari di apertura</h3>
          <button onClick={addHour} className="inline-flex items-center gap-1 text-xs text-gold-dark hover:text-gold">
            <Plus size={14} /> Aggiungi riga
          </button>
        </div>
        <div className="space-y-3">
          {hours.map((h, i) => (
            <div key={i} className="flex gap-3 items-center">
              <input value={h.d} onChange={(e) => setHour(i, "d", e.target.value)} placeholder="Giorni (es. Lunedì – Venerdì)" className="flex-1 bg-transparent border-b border-navy/15 py-2 text-sm text-navy placeholder:text-navy/30 focus:outline-none focus:border-gold" />
              <input value={h.h} onChange={(e) => setHour(i, "h", e.target.value)} placeholder="Orario (es. 08:00–13:00)" className="flex-1 bg-transparent border-b border-navy/15 py-2 text-sm text-navy placeholder:text-navy/30 focus:outline-none focus:border-gold" />
              <button onClick={() => removeHour(i)} aria-label="Rimuovi" className="text-navy/30 hover:text-red-500 transition-colors"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
